var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 4.7735C11.9607 4.76683 11.914 4.76683 11.874 4.7735C10.954 4.74017 10.2207 3.98683 10.2207 3.0535C10.2207 2.10016 10.9874 1.3335 11.9407 1.3335C12.894 1.3335 13.6607 2.10683 13.6607 3.0535C13.654 3.98683 12.9207 4.74017 12.0007 4.7735Z",
    stroke: "#F9FBFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3149 9.62694C12.2283 9.78027 13.2349 9.62027 13.9416 9.14694C14.8816 8.52027 14.8816 7.4936 13.9416 6.86694C13.2283 6.3936 12.2083 6.2336 11.2949 6.3936",
    stroke: "#F9FBFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98031 4.7735C4.02031 4.76683 4.06698 4.76683 4.10698 4.7735C5.02698 4.74017 5.76031 3.98683 5.76031 3.0535C5.76031 2.10016 4.99365 1.3335 4.04031 1.3335C3.08698 1.3335 2.32031 2.10683 2.32031 3.0535C2.32698 3.98683 3.06031 4.74017 3.98031 4.7735Z",
    stroke: "#F9FBFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6676 9.62694C3.75427 9.78027 2.7476 9.62027 2.04094 9.14694C1.10094 8.52027 1.10094 7.4936 2.04094 6.86694C2.75427 6.3936 3.77427 6.2336 4.6876 6.3936",
    stroke: "#F9FBFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0007 9.75348C7.9607 9.74681 7.91404 9.74681 7.87404 9.75348C6.95404 9.72015 6.2207 8.96681 6.2207 8.03348C6.2207 7.08014 6.98737 6.31348 7.9407 6.31348C8.89403 6.31348 9.6607 7.08681 9.6607 8.03348C9.65404 8.96681 8.9207 9.72681 8.0007 9.75348Z",
    stroke: "#F9FBFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06047 11.8532C5.12047 12.4799 5.12047 13.5066 6.06047 14.1332C7.12714 14.8466 8.8738 14.8466 9.94047 14.1332C10.8805 13.5066 10.8805 12.4799 9.94047 11.8532C8.88047 11.1466 7.12714 11.1466 6.06047 11.8532Z",
    stroke: "#F9FBFE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/crm.0c115adf436e373af3deff17738a0326.svg";
export { ForwardRef as ReactComponent };